(function ($) {

    const MOBILE_BREAKPOINT = 767; // uprav na skutečnou hodnotu vašeho @include max-sm breakpointu

    function isMobileViewport() {
        return window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`).matches;
    }

    function updateBulletsSingle(swiperInstance) {
        const bullets = swiperInstance.pagination.bullets;
        const activeIndex = swiperInstance.activeIndex;

        bullets.forEach((bullet, index) => {
            bullet.classList.toggle('swiper-pagination-bullet-active', index === activeIndex);
        });
    }

    function updateBulletsPaired(swiperInstance) {
        const bullets = swiperInstance.pagination.bullets;
        const activeIndex = swiperInstance.activeIndex;
        const lastIndex = bullets.length - 1;
        const lastVisibleIndex = activeIndex + 1;
        const isAtEnd = swiperInstance.isEnd;

        bullets.forEach((bullet, index) => {
            const shouldBeActive = index === lastIndex
                ? isAtEnd
                : index <= lastVisibleIndex;

            bullet.classList.toggle('swiper-pagination-bullet-active', shouldBeActive);
        });
    }

    function updateProductDetailBullets(swiperInstance) {
        if (isMobileViewport()) {
            updateBulletsSingle(swiperInstance);
        } else {
            updateBulletsPaired(swiperInstance);
        }
    }

    function initProductDetailSlider() {
        document.querySelectorAll('.product-post-detail__slider .swiper-container').forEach((container) => {
            if (container.swiper) return;

            const swiperInstance = new Swiper(container, {
                slidesPerView: 'auto',
                spaceBetween: 12,
                pagination: {
                    el: container.querySelector('.swiper-pagination'),
                    clickable: true,
                },
            });

            swiperInstance.on('slideChange', () => updateProductDetailBullets(swiperInstance));
            updateProductDetailBullets(swiperInstance);
        });
    }

    initProductDetailSlider();

    $(document).gp_ready(function () {
        initProductDetailSlider();
    });

    window.addEventListener('resize', () => {
        document.querySelectorAll('.product-post-detail__slider .swiper-container').forEach((container) => {
            if (container.swiper) {
                updateProductDetailBullets(container.swiper);
            }
        });
    });
})(jQuery);